module.exports = "/assets/js/45d0bc655ce37dbb47af59a9e74439ab.svg";